import { IMeeting, ceilMeasure, checkIsMeetingFor15Min, checkIsMetingInOneLine, getHeightFromDate, getShortUserName, setClass } from '@utils';
import React, { FC, MouseEvent, useEffect, useRef, useState } from 'react';
import { Accept, CrossRed } from '../../svgs';
import { getDateTitle } from '../utils';
import { Indicator } from './Indicator';

interface InfoProps {
  isDraggingMeeting: boolean;
  isShowInitiator: boolean;
  meeting: IMeeting;
  startDate: Date;
  endDate: Date;
  title: string;
  width: number;
  onMoveMouse: (e: MouseEvent<HTMLDivElement>) => void;
  onCancelDragging?: (e: MouseEvent<HTMLDivElement>) => void;
  onAcceptDragging?: () => void;
}
export const Info: FC<InfoProps> = ({ 
  isDraggingMeeting, isShowInitiator, meeting, startDate, endDate, 
  width, title, onCancelDragging, onAcceptDragging, onMoveMouse
}) => {
  const paddingX = 14;
  const timeRef = useRef<HTMLDivElement>();
  const countWidth = () => width - paddingX * 2 - timeRef?.current?.getBoundingClientRect()?.width;

  const [indicatorWidth, setIndicatorWidth] = useState(countWidth());

  useEffect(() => setIndicatorWidth(countWidth()), [width, timeRef?.current?.getBoundingClientRect()?.width])

  const height = getHeightFromDate(startDate, endDate);
  const isMeetingInOneLine = checkIsMetingInOneLine(startDate, endDate);
  const isShortMeeting = height <= 45 / ceilMeasure;
  const isLongMeetingForRoom = height > 92 / ceilMeasure && isShowInitiator;
  const onCancelDraggingHandler = (e: MouseEvent<HTMLDivElement>) => onCancelDragging && onCancelDragging(e);

  return (
    <div
      className='info'
      onMouseEnter={onMoveMouse}
      onMouseLeave={onMoveMouse}
      title={title}
      style={{
        gap: isShortMeeting || isMeetingInOneLine ? 6 : 8,
        flexDirection: isMeetingInOneLine ? 'row-reverse' : 'column',
        justifyContent: isMeetingInOneLine ? 'flex-end' : 'flex-start',
        paddingTop: `${isShortMeeting ? 3 : 12}px`,
      }}
    >
      <div className="name">
        {meeting.meetingName}
      </div>
      <div 
        className="time" 
        ref={timeRef}
      >
        {getDateTitle(startDate)}{height >= 30 ? ` -  ${getDateTitle(endDate)}` : ''}
      </div>
      {isLongMeetingForRoom && (
        <div className='initiator'>
          {`Организатор: ${getShortUserName(meeting.initiator.fullName)}`}
        </div>
      )}
      {isDraggingMeeting
        ? <div className={setClass("saving-time-actions", isShortMeeting && 'short', isMeetingInOneLine && 'one-line')}>
          <CrossRed
            divClassName='cancel'
            onClick={onCancelDraggingHandler}
          />
          <Accept
            divClassName='accept'
            onClick={onAcceptDragging}
          />
        </div>
        : <Indicator
          visible={indicatorWidth>=20 || !isShortMeeting }
          meeting={meeting}
          height={height}
        />
      }
    </div>
  );
};